module.exports = __webpack_public_path__ + "img/15.641b7217.png";